const Puce = ({ color, radius }) => {

    const customStyle =
    {
        height: `${radius}px`,
        width: `${radius}px`,
        borderRadius: `${radius}px`,
        background: `${color}`,
    }

    return (
        <div style={customStyle} />
    )

}

export default Puce;